var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import id from "@irati/utils/id";
import { Label } from "@irati/ui/src/Typography";
import ImageRouterLink from "../ImageRouterLink";
import TagRouterLink from "./styled/TagRouterLink";
var TopCategories = /** @class */ (function (_super) {
    __extends(TopCategories, _super);
    function TopCategories() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopCategories.prototype.renderTagLinks = function (categories, idNamespace) {
        var _this = this;
        return categories.map(function (category) {
            var linkProps = _this.generateLinkProps(category, idNamespace);
            return (React.createElement(TagRouterLink, __assign({ key: category.uuid }, linkProps), category.name));
        });
    };
    TopCategories.prototype.generateLinkProps = function (category, idNamespace) {
        return {
            id: id("link--" + category.uuid, idNamespace, { prefix: "categories" }),
            to: "/categories/" + category.url
        };
    };
    TopCategories.prototype.renderImageLinks = function (categories, idNamespace) {
        var _this = this;
        return (React.createElement(Row, null, categories.map(function (category) {
            var linkProps = _this.generateLinkProps(category, idNamespace);
            return (React.createElement(Col, { sm: 3, key: category.uuid },
                React.createElement(ImageRouterLink, __assign({}, linkProps, { image: category.image }),
                    React.createElement(Label, { large: true, color: "white", uppercase: true }, category.name))));
        })));
    };
    TopCategories.prototype.render = function () {
        var _a = this.props, categories = _a.categories, mq = _a.mq, className = _a.className;
        var idNamespace = id("top-categories", this.props);
        var isMobile = mq.lessThan.md;
        return (React.createElement("div", { className: className },
            isMobile && this.renderTagLinks(categories, idNamespace),
            !isMobile && this.renderImageLinks(categories, idNamespace)));
    };
    return TopCategories;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({ mq: mq });
};
export default connect(mapStateToProps)(TopCategories);
